export enum ENotification {
  getData = 'notifications/getData',
  readNotifications = 'notifications/read',
  addNotification = 'notifications/add',
}
